export default "__VITE_ASSET__6CPs2ZWe__"